






import Vue from 'vue'
export default class FaqContent extends Vue{
    mounted() {

    }
}
